import React from 'react';
import { Loader } from '@consta/uikit/Loader';
import cn from 'classnames/bind';
import styles from './styles.styl';

const cx = cn.bind(styles);

export interface ICenterLoaderProps {
  height?: string;
}

const CenterLoader: React.FC<ICenterLoaderProps> = ({ height }) => {
  return (
    <div className={cx('CenterLoader')} style={{ height }}>
      <Loader />
    </div>
  );
};

export default CenterLoader;
